import React from "react";

const RULES = [
  { label: "Mínimo 8 caracteres",       test: (p) => p.length >= 8 },
  { label: "Al menos una mayúscula",     test: (p) => /[A-Z]/.test(p) },
  { label: "Al menos una minúscula",     test: (p) => /[a-z]/.test(p) },
  { label: "Al menos un número",         test: (p) => /[0-9]/.test(p) },
  { label: "Al menos un carácter especial", test: (p) => /[^A-Za-z0-9]/.test(p) },
];

/**
 * Muestra en tiempo real qué reglas cumple/falta la contraseña.
 * Props:
 *   password  — string — la contraseña que el usuario está escribiendo
 *   visible   — boolean (opcional, default true) — ocultar el checklist si es falso
 */
function PasswordStrengthChecklist({ password = "", visible = true }) {
  if (!visible) return null;

  return (
    <ul
      style={{
        listStyle: "none",
        padding: "8px 0 4px",
        margin: 0,
        fontSize: "11px",
        lineHeight: "1.8",
      }}
    >
      {RULES.map(({ label, test }) => {
        const ok = password.length > 0 && test(password);
        const pending = password.length === 0;
        return (
          <li
            key={label}
            style={{
              color: pending
                ? "var(--text-muted)"
                : ok
                  ? "var(--chart-positive, #4ade80)"
                  : "var(--error-color, #ef4444)",
              display: "flex",
              alignItems: "center",
              gap: "6px",
            }}
          >
            <span style={{ fontWeight: 700, fontSize: "13px", lineHeight: 1 }}>
              {pending ? "·" : ok ? "✓" : "✗"}
            </span>
            {label}
          </li>
        );
      })}
    </ul>
  );
}

export default PasswordStrengthChecklist;
